var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99989 5.9375C4.81712 5.9375 4.63426 5.87036 4.49498 5.73608L0.209263 1.61108C-0.0697545 1.34253 -0.0697545 0.907471 0.209263 0.638916C0.488281 0.370361 0.94029 0.370361 1.21931 0.638916L4.99989 4.27891L8.78114 0.639453C9.06016 0.370898 9.51217 0.370898 9.79118 0.639453C10.0702 0.908008 10.0702 1.34307 9.79118 1.61162L5.50547 5.73662C5.36596 5.8709 5.18292 5.9375 4.99989 5.9375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.7b95a6d51eedca4a5c17315cdb877321.svg";
export { ForwardRef as ReactComponent };